var Student = "Học sinh/sinh viên";
var jobRole = {
	"Job role": "Chức vụ",
	"Academic / Researcher": "Viện sĩ/Nhà nghiên cứu",
	"Advisor / Consultant": "Cố vấn/Chuyên viên tư vấn",
	"Business Executive": "Cán bộ điều hành kinh doanh",
	"Developer / Engineer": "Nhà phát triển/Kỹ sư",
	"Entrepreneur (Founder/Co-Founder)": "Doanh nhân (Người sáng lập/Người đồng sáng lập)",
	"IT Executive": "Cán bộ điều hành CNTT",
	"IT Professional or Technical Manager": "Chuyên gia CNTT hoặc Quản lý kỹ thuật",
	"Press / Media Analyst": "Nhân viên phân tích truyền thông/báo chí",
	"Sales / Marketing": "Bán hàng/tiếp thị",
	Student: Student,
	"Solution or Systems Architect": "Kiến trúc sư giải pháp hoặc hệ thống",
	"System Administrator": "Quản trị viên hệ thống",
	"Venture Capitalist": "Nhà đầu tư mạo hiểm"
};

export { Student, jobRole as default };
